
import { useMemo } from "react";

export const useLateAttendanceStats = (filteredStudents: any[], filteredLateRecords: any[]) => {
  return useMemo(() => {
    const totalStudents = filteredStudents.length;
    
    // معالجة سريعة للبيانات
    const validStudents = filteredStudents.map(s => ({
      ...s,
      lateDays: Number(s.lateDays) || 0
    }));
    
    const totalLateStudents = validStudents.filter(s => s.lateDays > 0).length;
    const totalOnTimeStudents = totalStudents - totalLateStudents;
    const totalLateInstances = validStudents.reduce((sum, s) => sum + s.lateDays, 0);
    
    const latePercentage = totalStudents > 0 ? 
      Math.round((totalLateStudents / totalStudents) * 100) : 0;
    
    const attendanceRate = filteredStudents.length > 0 ? 
      Math.round(filteredStudents.reduce((sum, s) => sum + (s.attendancePercentage || 0), 0) / filteredStudents.length) : 0;

    return {
      totalLateStudents,
      totalOnTimeStudents,
      totalLateInstances,
      latePercentage,
      attendanceRate,
      totalStudents
    };
  }, [filteredStudents]);
};
